import { forwardRef } from 'react';

const Layout = forwardRef(({ children }, ref) => (
  <div
    ref={ref}
    className="relative grid gap-y-xl gap-x-5xl mb-5xl laptop:mb-6xl laptop:grid-cols-2">
    <>{children[0]}</>
    <>{children[1]}</>
  </div>
));

export default Layout;
